if (!customElements.get("product-form")) {
    customElements.define(
      "product-form",
      class ProductForm extends HTMLElement {
        constructor() {
          super();
  
          this.form = this.querySelector("form");
          this.isCustom = this.parentNode.parentNode.querySelector(
            "custom-variant"
          )
            ? true
            : false;
          this.form.querySelector("[name=id]").disabled = false;
          this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
          this.cart =
            document.querySelector("cart-notification") ||
            document.querySelector("cart-drawer");
          this.submitButton = this.querySelector('[type="submit"]');
          if (document.querySelector("cart-drawer"))
            this.submitButton.setAttribute("aria-haspopup", "dialog");
        }
     async onSubmitHandler(evt) {
  evt.preventDefault();
  if (this.submitButton.getAttribute("aria-disabled") === "true") return;

  this.handleErrorMessage();

  this.submitButton.setAttribute("aria-disabled", true);
  this.submitButton.classList.add("loading");
  this.querySelector(".loading-overlay__spinner").classList.remove("hidden");

  const config = fetchConfig("javascript");
  config.headers["X-Requested-With"] = "XMLHttpRequest";
  delete config.headers["Content-Type"];
       
    let logoFirstProductId = null
    let logoFirst = null
    let logoSizeShape =null
    let logoSize = null;
    let logoColor = null;
    let selectedValues = [];
    let fileInput = null;
    let files = null
    let logoMaterialId = null
    let logoMaterialName = null
if (document.querySelector(".product_custom_logo_content")) {
    let isCustomLogo = document.querySelector(".product_custom_logo_content").classList.contains("active");
   
    if (isCustomLogo) {
      fileInput = document.querySelector('#product_custom_logo_file');
      if (fileInput && fileInput.files.length > 0) {
        files = fileInput.files[0]
      }
      if (document.querySelector('input[name="is_first"]')) {
        if (document.querySelector('input[name="is_first"]:checked').value != 'no_first') {
          logoFirstProductId = document.querySelector('input[name="is_first"]:checked').value
          logoFirst = "YES"
        }else{
          logoFirstProductId = null
          logoFirst = "NO"
        }
      }
      
      logoSizeShape = document.querySelector(".product_custom_logo_size_shape_select").value;
      logoSize = document.querySelector(".product_custom_logo_size_select").value;
      logoColor = document.querySelector("#product_custom_logo_color").value;
      
      logoMaterialId = document.querySelector('input[name="product_custom_logoMaterial"]:checked').value
      logoMaterialName = document.querySelector('input[name="product_custom_logoMaterial"]:checked').getAttribute("data-name")
      
      selectedValues = Array.from(document.querySelectorAll('input[name="custom_logo_position"]:checked')).map((checkbox) => checkbox.value);
    }
    selectedValues = selectedValues.join(",");
}
 
  let formData = new FormData(this.form);
 
  if (this.isCustom) {
     let filteredFormData = new FormData();
    for (let [key, value] of formData.entries()) {
      if (key !== "id") { 
        filteredFormData.append(key, value);
      }
    }
    const inputList = this.parentNode.parentNode.querySelectorAll("custom-quantity-input");
    
    const items = [];
    let items_length = 0
    Array.from(inputList).forEach((ele,index) => {
      const id = Number(ele.dataset.id);
      const quantity = Number(ele.querySelector("input").value);
      if (quantity) {
        let item = { id, quantity };
        item.properties={
           ...(files && { customLogo: files }),
           ...(logoFirst && { logoFirst: logoFirst }),
          ...(logoSize && { logoSize }),
          ...(logoSizeShape && { logoSizeShape }),
          ...(logoColor && { logoColor }),
          ...(selectedValues && {customPosition:selectedValues}),
          ...(logoMaterialName && {logoMaterialName:logoMaterialName})
        }
        filteredFormData.append(`items[${items_length}]id`,item.id)
        filteredFormData.append(`items[${items_length}]quantity`,item.quantity)
        if (item.properties.customLogo) {
          filteredFormData.append(`items[${items_length}]properties[customLogo]`,item.properties.customLogo)
        }
        if (item.properties.logoColor) {
        filteredFormData.append(`items[${items_length}]properties[logoColor]`,item.properties.logoColor)
        }
        if (item.properties.logoSize) {
        filteredFormData.append(`items[${items_length}]properties[logoSize]`,item.properties.logoSize)
        }
           if (item.properties.logoFirst) {
        filteredFormData.append(`items[${items_length}]properties[logoFirst]`,item.properties.logoFirst)
        }
        if (item.properties.logoSizeShape) {
        filteredFormData.append(`items[${items_length}]properties[logoSizeShape]`,item.properties.logoSizeShape)
        }
        if (item.properties.customPosition != "") {
        filteredFormData.append(`items[${items_length}]properties[customPosition]`,item.properties.customPosition)
        }
       if (item.properties.logoMaterialName) {
        filteredFormData.append(`items[${items_length}]properties[logoMaterialName]`,item.properties.logoMaterialName)
        }
        items_length += 1    
      }
    });
    if (logoFirstProductId) {
       filteredFormData.append(`items[${items_length}]id`,logoFirstProductId)
        filteredFormData.append(`items[${items_length}]quantity`,"1")
        items_length += 1    
    }
    if (logoMaterialId) {
      const selectedCount = $("input[name='custom_logo_position']:checked").length;
      const total_count = document.querySelector(".product_custom_total").innerHTML * 1
       filteredFormData.append(`items[${items_length}]id`,logoMaterialId)
       filteredFormData.append(`items[${items_length}]quantity`,selectedCount * total_count)
       items_length += 1    
    }
    if (this.cart) {
      filteredFormData.append("sections", this.cart.getSectionsToRender().map((section) => section.id).join(","));
      filteredFormData.append("sections_url", window.location.pathname);
      this.cart.setActiveElement(document.activeElement);
    }
    formData = filteredFormData
  } else {
    if (this.cart) {
      formData.append("sections", this.cart.getSectionsToRender().map((section) => section.id).join(","));
      formData.append("sections_url", window.location.pathname);
      this.cart.setActiveElement(document.activeElement);
    }
  }
   formData.forEach((value, key) => {
        console.log(`${key}:`, value);
        console.log("-------");
    });
  fetch(`${Shopify.routes.root}cart/add.js`, {
    body:formData,
     method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest"
      }
  })
    .then((response) => response.json())
    .then((response) => {
      console.log(response);
      if (response.status) {
        this.handleErrorMessage(response.description);

        const soldOutMessage = this.submitButton.querySelector(".sold-out-message");
        if (!soldOutMessage) return;
        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.querySelector("span").classList.add("hidden");
        soldOutMessage.classList.remove("hidden");
        this.error = true;
        return;
      } else if (!this.cart) {
        window.location = window.routes.cart_url;
        return;
      }

      this.error = false;
      const quickAddModal = this.closest("quick-add-modal");
      console.log(quickAddModal)
      console.log(response)
      if (quickAddModal) {
        document.body.addEventListener("modalClosed", () => {
          setTimeout(() => {
            this.cart.renderContents(response);
          });
        }, { once: true });
        quickAddModal.hide(true);
      } else {
        this.cart.renderContents(response);
      }
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      this.submitButton.classList.remove("loading");
      if (this.cart && this.cart.classList.contains("is-empty")) this.cart.classList.remove("is-empty");
      if (!this.error) this.submitButton.removeAttribute("aria-disabled");
      this.querySelector(".loading-overlay__spinner").classList.add("hidden");
    });
}

  
        handleErrorMessage(errorMessage = false) {
          this.errorMessageWrapper =
            this.errorMessageWrapper ||
            this.querySelector(".product-form__error-message-wrapper");
          if (!this.errorMessageWrapper) return;
          this.errorMessage =
            this.errorMessage ||
            this.errorMessageWrapper.querySelector(
              ".product-form__error-message"
            );
  
          this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);
  
          if (errorMessage) {
            this.errorMessage.textContent = errorMessage;
          }
        }
      }
    );
  }
  